<div class="backgroundColor backgroundColor star-dust darken-3">
  <section class="container-fluid backgroundColor star-dust darken-3 position-relative top-119" id="my-element">
    <div class="container">
      <div class="row pt-48 pb-16">
        <div class="col-12">
          <div class="col-6 mx-auto backgroundColor mine-shaft base p-5 text-white rounded-lg">
            <div class="d-flex justify-content-center mb-10">
              <img src="../../assets/images/logo/relojoariaFaria.svg" class="img-fluid" width="120px" alt="">
            </div>
            <h1 class="d-flex justify-content-center mb-5 font-italic text-shadow">Recuperação de Conta</h1>
            <div class="form-group">
              <label class="mb-3" for="exampleInputEmail1">Insira o email para o qual pretende receber o link de recuperação</label>
              <input type="email" class="form-control" aria-describedby="emailHelp" [(ngModel)]="email">
            </div>
            <button type="submit" class="btn btn-outline-secondary mt-10 text-white px-4" (click)="send()">Enviar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>